<div [formlyAttributes]="field" class="hotkey-wrapper">
  <label>{{ field.templateOptions?.label }}</label>
  <hotkey-input [formControl]="formControl"></hotkey-input>
</div>
